import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    PopoverSurfaceStatusDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center"
    },
    text: {
        flexShrink: 1
    }
});

export const useStyles = ({
    controlHeights,
    spaces
}: PopoverSurfaceStatusDynamicStyleType) => {
    const styles = {
        container: {
            paddingHorizontal: spaces.spacingSm,
            minHeight: controlHeights.small,
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
